import React, { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { Toast } from "primereact/toast";
import { DialogShow, DialogShow_2 } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";

import "../../../components/DataTable/DataTable.css";

import P211List from "./P211List";
import P211Search from "./P211Search";
import P212 from "../212/P212";
import P213 from "../213/P213";

import { P211GetDataList } from "../../../service/200/P211Service";
import { P212GetColumnList, P212GetDataList, P212UpdateData } from "../../../service/200/P212Service";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { P213GetColumnList, P213GetDataList, P213UpdateData } from "../../../service/200/P213Service";
import { ZeroToNull } from "../../../utilities/NullUtil";

export default function P211() {

    const history = useHistory();
    const location = useLocation();

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);

    const [dataTableB, setDataTableB] = useState([]);
    const [dataTableColB, setDataTableColB] = useState([]);
    const [keyListB, setKeyListB] = useState(['','']);

    const [dataTableC, setDataTableC] = useState([]);
    const [dataTableColC, setDataTableColC] = useState([]);
    const [keyListC, setKeyListC] = useState(['','']);

    const [columnNo, setColumnNo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [indexTab, setIndexTab] = useState(1);

    // SEARCH
    const [searchData, setSearchData] = useState({
        "contractNo": "",
        userId: dataUserSession()?dataUserSession().userId:'',
        ...history.location.state?history.location.state:''
    });

    const [show, setShow] = useState(false);

    useEffect( () => {
        setLoading(true);
        setTimeout(async () => {
            onP211GetDataList();
            await Promise.all([
                onP212GetColumnList(),
                onP212GetDataList(),
                onP213GetColumnList(),
                onP213GetDataList(),
            ]);
        }, 10);
        onTabActive();
        setLoading(false);
    }, [searchData])

    useEffect(() => {
        if (dataUserSession()) {
            if (!history.location.state ) {
                history.push("/208");
            } else{
                if(history.location.state.contractNo === false ){
                    history.push("/208");
                }
                if(history.location.state.page){
                    // setIndexTab(1);
                }
            }

        } else {
            history.push("/login");
        }
    }, []);

    const onTabActive = (list) =>{
        if(location && location.pathname){
            switch (location.pathname) {
                case '/213':{
                    // if(list === 'C'){
                        setIndexTab(2);
                    // }
                    break;
                }
                case '/212': {
                    // if(list === 'B'){
                        setIndexTab(1);
                    // }
                    break;
                }
                case '/211':
                default:
                    setIndexTab(0); break;
            }
        }
        setShow(true)
    }

    const onP211GetDataList = () => {
        setLoading(true);
        P211GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    // setDataTable(temp);
                    modifyDataTab1(temp);
                    // setColumnNo(newData[0])
                    // setDataTable(newData.splice(1))

                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP212GetColumnList = async () => {
        setLoading(true);
        await P212GetColumnList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('hd ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let keyList = ['','']
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            contractAmount: ZeroToNull(element.contractAmount) ,
                            contractUnit: ZeroToNull(element.contractUnit) ,
                            itemUnitPrice: ZeroToNull(element.itemUnitPrice) ,
                            index: index,
                        });

                        keyList.push(element.updateKey)
                        index++;
                    });

                    setKeyListB(keyList);
                    setDataTableB(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP212GetDataList = async () => {
        setLoading(true);
         await P212GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('col ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableColB(temp);
                }else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP213GetColumnList = async () => {
        setLoading(true);
        await P213GetColumnList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('hd ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let keyList = ['','']
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            contractAmount: ZeroToNull(element.contractAmount) ,
                            contractUnit: ZeroToNull(element.contractUnit) ,
                            itemUnitPrice: ZeroToNull(element.itemUnitPrice) ,
                            index: index,
                        });

                        keyList.push(element.updateKey)
                        index++;
                    });

                    setKeyListC(keyList);
                    setDataTableC(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP213GetDataList = async () => {
        setLoading(true);
         await P213GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('col ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableColC(temp);
                }else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const goPage = (page) => {
        if(page){
            history.push({
                pathname: page,
            });
        }else{
            history.push("/200");
        }
    };

    const modifyDataTab1 = (data)=>{

        let newData =[];
        let index = 1;
        let hdRow = {};
        let colTmp =0;
        let rowTmp = 1;

        data.forEach((obj) => {
            if(obj.rowNo === 1){
                // hdRow.push({ ['column'+index]: obj.cellValue})
                hdRow = {
                    ...hdRow,
                    ['columnNO'+index]: obj.cellValue
                }
                index++;
            }else {
                if(obj.columnNO === 1){
                    newData.push({['columnNO'+obj.columnNO]:obj.cellValue})
                }else{
                    if(colTmp !== obj.columnNO){
                        newData[0]={
                            ...newData[0],
                            ['columnNO'+obj.columnNO]:obj.cellValue
                        }
                        colTmp = obj.columnNO
                        rowTmp = 1;
                    }else{
                            newData[rowTmp]={
                                ...newData[rowTmp],
                                ['columnNO'+obj.columnNO]:obj.cellValue
                            }
                            rowTmp++;

                    }

                }
            }
        })
        setColumnNo(hdRow)
        setDataTable(newData)

    }

    const submitForm = async (submitForm,page) => {
        if(submitForm && submitForm.length >0 ){
            setLoading(true);
            await Promise.all(submitForm.map(async (item) => {
                if(item.updateKey && item.updateKey !== null && item.updateKey !== ''){
                    if(page === 212){
                        await onP212UpdateData(item)
                    }else if(page === 213){
                        await onP213UpdateData(item)
                    }
                }
            }));


            // alert('You clicked on: ' + count);
            setLoading(false);
            // await setIndexTab(0);

            history.push({
                pathname: '211',
                state: {
                    contractNo: searchData.contractNo,
                    routeNo: searchData.routeNo ,
                    contractorName : searchData.contractorName,
                    supervisorName : searchData.supervisorName,
                    page : page
                },
            });
            // onP211GetDataList();
            // await onP212GetColumnList();
            // await onP212GetDataList();
            // await onP213GetColumnList();
            // await onP213GetDataList();
            // onTabActive();

        }


        // setDialog(false);
        // onP206GetPicDataList(setLoading, setDataPic, searchData, setErrData);

    };

    const onP212UpdateData =  async (dataReq) => {
        await P212UpdateData(dataReq).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {

                    if(res.data[0].statusCode === 'C'){
                        setTextShow(`บันทึกสมบูรณ์`);
                    }else if(res.data[0].statusCode === 'E'){
                        setTextShow(`มีข้อผิดพลาด`);
                    }else{
                        setTextShow(`${res.data[0].statusText}`);
                    }

                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }


            },
            function (err) {

                setErrData(err)
            }
        );
    };

    const onP213UpdateData =  async (dataReq) => {
        await P213UpdateData(dataReq).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {

                    if(res.data[0].statusCode === 'C'){
                        setTextShow(`บันทึกสมบูรณ์`);
                    }else if(res.data[0].statusCode === 'E'){
                        setTextShow(`มีข้อผิดพลาด`);
                    }else{
                        setTextShow(`${res.data[0].statusText}`);
                    }

                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }


            },
            function (err) {

                setErrData(err)
            }
        );
    };


    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12" >
                    <div className="card">
                        <P211Search data={searchData}  goPage={goPage} />
                        <br/>
                        {
                            show && show === true ?(
                                <TabView activeIndex={indexTab} >
                                    <TabPanel header="สรุปค่างานเส้นทาง">
                                        <P211List dataTable={dataTable} columnNo={columnNo}/>
                                    </TabPanel>

                                    <TabPanel header="ประมาณการ">
                                        <P212
                                            dataTable={dataTableB}
                                            dataCol={dataTableColB}
                                            keyListB={keyListB}
                                            searchData={searchData}
                                            goPage={goPage}
                                            submitForm = {submitForm}
                                        />
                                    </TabPanel>

                                    <TabPanel header="กระดาษทด-รวม">
                                        <P213
                                            dataTable={dataTableC}
                                            dataCol={dataTableColC}
                                            keyListB={keyListC}
                                            searchData={searchData}
                                            goPage={goPage}
                                            submitForm = {submitForm}
                                        />
                                    </TabPanel>
                                </TabView>
                            ):('')

                        }
                    </div>
                </div>
            </div>

            <DialogShow_2
                visible={showDialog}
                header="แจ้งเตือน" modal
                onHide={() => setShowDialog(false)}
                className="p-fluid"
                textContent={textShow}
                btnCancle={() => setShowDialog(false)}
            />

        </>
    );
}
